import type { GameMeta } from "@/app/game-definition.mjs";
import type { GameSymbol } from "@/app/games.mjs";
import { proxy } from "@/util/proxy.mjs";

export default proxy({
  guides: {},
  Leaderboard: null,
} as {
  guides: Record<GameSymbol, GameMeta["guides"]>;
  Leaderboard: unknown | null;
});
